import React, { lazy, Suspense } from 'react';
import { Skeleton } from '@mui/material';
import type { MaturityTrendDataPoint } from './MaturityTrendChart';

// Lazy load the Chart.js component
const MaturityTrendChart = lazy(() =>
  import('./MaturityTrendChart').then(module => ({
    default: module.MaturityTrendChart
  }))
);

interface MaturityTrendChartLazyProps {
  data: MaturityTrendDataPoint[];
  loading?: boolean;
}

export function MaturityTrendChartLazy({ data, loading = false }: MaturityTrendChartLazyProps) {
  return (
    <Suspense
      fallback={
        <Skeleton
          variant="rectangular"
          height={300}
          aria-label="Loading signal maturity trend chart"
        />
      }
    >
      <MaturityTrendChart data={data} loading={loading} />
    </Suspense>
  );
}
